// B2-INT - Ünite 1: Behavioral Sorular (STAR Metodu)
// B2 seviyesinde mülakat senaryoları - STAR tekniği ile cevap verme

export const B2INT_UNIT_1 = {
  'B2INT-U1-L1': {
    id: 'B2INT-U1-L1',
    title: 'STAR Method Nedir?',
    type: 'interview',
    content: {
      sections: [
        {
          type: 'intro',
          title: '🎯 STAR Metodu - Behavioral Soruların Anahtarı',
          content: 'STAR metodu, "Tell me about a time when..." gibi geçmiş deneyim sorularına yapılandırılmış cevap verme tekniğidir.\n\nHavayolları bu tekniği MUTLAKA bekler çünkü:\n• Somut örnekler isterler\n• Soyut "Ben iyiyim" cevapları YETERSİZ\n• Gerçek deneyimlerinizi görmek isterler'
        },
        {
          type: 'framework',
          title: '📋 STAR Çerçevesi',
          content: '**S - Situation (Durum)**\nNe oldu? Bağlam ne?\n"In my previous job at a hotel..."\n\n**T - Task (Görev)**\nSenin sorumluluğun neydi?\n"My responsibility was to..."\n\n**A - Action (Eylem)**\nNe yaptın? (EN ÖNEMLİ KISIM!)\n"I decided to... First, I... Then, I..."\n\n**R - Result (Sonuç)**\nSonuç ne oldu? Mümkünse sayılarla!\n"As a result, the customer... / The situation was resolved..."'
        },
        {
          type: 'scenario',
          title: '✈️ STAR Örneği: Zor Müşteri',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'Tell me about a time you dealt with a difficult customer.',
              translation: 'Zor bir müşteriyle uğraştığınız bir zamanı anlatın.'
            },
            {
              speaker: 'Aday (STAR Cevabı)',
              text: 'SITUATION: Last summer, while working at a busy hotel in Antalya, a guest arrived at 2 AM extremely angry because his room had been given to someone else due to an overbooking.',
              translation: 'DURUM: Geçen yaz, Antalya\'da yoğun bir otelde çalışırken, gece 2\'de bir misafir çok kızgın geldi çünkü fazla rezervasyon nedeniyle odası başkasına verilmişti.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'TASK: As the night receptionist, it was my responsibility to find a solution and calm the guest down, even though I was alone and all rooms were fully booked.',
              translation: 'GÖREV: Gece resepsiyonisti olarak, yalnız olmama ve tüm odalar dolu olmasına rağmen bir çözüm bulmak ve misafiri sakinleştirmek benim sorumluluğumdu.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'ACTION: First, I sincerely apologized and acknowledged his frustration. Then, I offered him complimentary coffee while I contacted three nearby partner hotels. I found an available suite at a 5-star property and arranged free transportation for him.',
              translation: 'EYLEM: Önce içtenlikle özür diledim ve hayal kırıklığını kabul ettim. Sonra üç yakın ortak otelle iletişime geçerken ona ücretsiz kahve ikram ettim. 5 yıldızlı bir otelde müsait bir suit buldum ve ona ücretsiz ulaşım ayarladım.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'RESULT: The guest was impressed by the quick solution. He actually thanked me and later left a 5-star review mentioning my name. My manager also recognized me as "Employee of the Month."',
              translation: 'SONUÇ: Misafir hızlı çözümden etkilendi. Bana teşekkür etti ve daha sonra adımı belirten 5 yıldızlı bir yorum bıraktı. Müdürüm de beni "Ayın Çalışanı" seçti.'
            }
          ]
        },
        {
          type: 'analysis',
          title: '📊 Cevap Analizi',
          content: '✅ **S - Situation:** Net bağlam (otel, gece, overbooking)\n✅ **T - Task:** Sorumluluk belirtildi (çözüm bul, sakinleştir)\n✅ **A - Action:** Detaylı adımlar (özür, kahve, telefon, çözüm, ulaşım)\n✅ **R - Result:** Ölçülebilir sonuç (5 yıldız, Employee of Month)\n\n**Toplam süre:** 60-90 saniye (İDEAL!)'
        },
        {
          type: 'warning',
          title: '⚠️ STAR Hataları',
          content: '❌ Sadece Situation anlatıp Action\'ı atlama\n❌ "We did..." demek (SEN ne yaptın?)\n❌ Result\'ı unutmak\n❌ Çok uzun cevap (2 dakikadan fazla)\n❌ Somut olmayan cevap ("I handle situations well")'
        },
        {
          type: 'tip',
          content: '💡 ALTIN KURAL: Action bölümü en uzun olmalı! Mülakatçılar SEN\'in ne yaptığını görmek ister, ne olduğunu değil.'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'STAR metodunda hangi bölüm en uzun olmalı?',
          options: [
            'Situation - detaylı bağlam',
            'Task - sorumluluk açıklaması',
            'Action - ne yaptığını anlatma',
            'Result - sonuçları sıralama'
          ],
          correctIndex: 2,
          explanation: 'Action en önemli ve en uzun bölüm olmalı - SEN ne yaptın!'
        },
        {
          type: 'multipleChoice',
          question: 'STAR cevabı ideal olarak kaç dakika olmalı?',
          options: [
            '30 saniye',
            '1-1.5 dakika',
            '3-4 dakika',
            '5+ dakika'
          ],
          correctIndex: 1,
          explanation: '60-90 saniye ideal. Çok kısa = yetersiz, çok uzun = sıkıcı.'
        }
      ]
    }
  },

  'B2INT-U1-L2': {
    id: 'B2INT-U1-L2',
    title: 'Tell me about a time you dealt with a difficult situation',
    type: 'interview',
    content: {
      sections: [
        {
          type: 'intro',
          title: '🎯 Bu Soru Ne Test Ediyor?',
          content: 'Bu klasik behavioral soru şunları ölçer:\n\n• Problem çözme yeteneği\n• Baskı altında sakin kalma\n• İnisiyatif alma\n• Sonuç odaklı düşünme\n\n⚠️ "Difficult situation" = İş ile ilgili olmalı, kişisel değil!'
        },
        {
          type: 'scenario',
          title: '✈️ Mülakat Senaryosu: Güçlü Cevap',
          dialogues: [
            {
              speaker: 'Mülakatçı (Senior HR)',
              text: 'Tell me about a time you faced a difficult situation at work. How did you handle it?',
              translation: 'İşte zor bir durumla karşılaştığınız bir zamanı anlatın. Nasıl üstesinden geldiniz?'
            },
            {
              speaker: 'Aday (STAR)',
              text: 'Certainly. SITUATION: During my time as a restaurant supervisor, we had a night where three servers called in sick during our busiest Saturday. We had 150 reservations and only 4 servers instead of 7.',
              translation: 'Tabii. DURUM: Restoran süpervizörü olarak çalışırken, en yoğun Cumartesi gecemizde üç garson hasta olarak aradı. 150 rezervasyonumuz vardı ve 7 yerine sadece 4 garsonumuz vardı.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'TASK: As the shift supervisor, I had to ensure smooth service despite being severely understaffed. Customer satisfaction was critical - one bad review could hurt our reputation.',
              translation: 'GÖREV: Vardiya süpervizörü olarak, ciddi personel eksikliğine rağmen sorunsuz hizmet sağlamam gerekiyordu. Müşteri memnuniyeti kritikti - bir kötü yorum itibarımıza zarar verebilirdi.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'ACTION: I quickly restructured the floor plan - combining sections to reduce walking distance. I jumped in as a server myself while coordinating. I also briefed the kitchen to simplify the menu for faster service.',
              translation: 'EYLEM: Hızla kat planını yeniden yapılandırdım - yürüme mesafesini azaltmak için bölümleri birleştirdim. Koordine ederken kendim de garson olarak atladım. Ayrıca daha hızlı servis için menüyü basitleştirmesi için mutfağı bilgilendirdim.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'I communicated proactively with guests, explaining potential wait times honestly. Most appreciated the transparency. I also offered complimentary appetizers to tables that waited longer.',
              translation: 'Misafirlerle proaktif iletişim kurdum, olası bekleme sürelerini dürüstçe açıkladım. Çoğu şeffaflığı takdir etti. Ayrıca daha uzun bekleyen masalara ücretsiz mezeler ikram ettim.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'RESULT: We served all 150 guests that night with only 2 minor complaints. Our online reviews from that evening were actually 4.7 stars. The owner personally thanked me and gave me a bonus.',
              translation: 'SONUÇ: O gece sadece 2 küçük şikayetle 150 misafirin hepsine hizmet verdik. O akşamdan online yorumlarımız aslında 4.7 yıldızdı. Patron şahsen teşekkür etti ve bana bonus verdi.'
            }
          ]
        },
        {
          type: 'analysis',
          title: '📊 Neden Güçlü Bir Cevap?',
          content: '✅ **Somut sayılar:** 150 rezervasyon, 4/7 garson, 4.7 yıldız\n✅ **Birden fazla Action:** Yeniden yapılandırma, kendisi de çalışma, mutfak koordinasyonu, iletişim, ücretsiz ikram\n✅ **Liderlik gösterdi:** Kriz anında sorumluluk aldı\n✅ **Pozitif sonuç:** Şikayetler minimum, bonus aldı'
        },
        {
          type: 'scenario',
          title: '❌ Kaçınılması Gereken Cevap',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'Tell me about a difficult situation at work.',
              translation: 'İşteki zor bir durumu anlatın.'
            },
            {
              speaker: 'Zayıf Cevap',
              text: 'I\'m generally good at handling difficult situations. I stay calm and always find a way to solve problems. In my last job, there were many difficult situations but I managed them well.',
              translation: 'Genellikle zor durumları iyi idare ederim. Sakin kalırım ve her zaman sorunları çözmenin bir yolunu bulurum. Son işimde birçok zor durum vardı ama iyi yönettim.'
            }
          ]
        },
        {
          type: 'warning',
          title: '⚠️ Bu Cevabın Sorunları',
          content: '❌ Somut örnek YOK\n❌ STAR yapısı YOK\n❌ Ne yaptığı belli DEĞİL\n❌ Sonuç YOK\n❌ Sadece genel ifadeler ("I\'m good at...")'
        },
        {
          type: 'tip',
          content: '💡 PRO TIP: Her zaman ÖNCE örneği anlat. "I\'m good at..." gibi genel ifadelerle BAŞLAMA!'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: '"Difficult situation" sorusu için EN İYİ örnek?',
          options: [
            'Ailemde bir sorun yaşadığımda',
            'İş yerinde beklenmedik bir kriz çözdüğümde',
            'Sınavda zorlandığımda',
            'Arkadaşlarımla tartıştığımda'
          ],
          correctIndex: 1,
          explanation: 'İş ile ilgili, profesyonel bir örnek seç - kişisel değil!'
        }
      ]
    }
  },

  'B2INT-U1-L3': {
    id: 'B2INT-U1-L3',
    title: 'Describe a time you worked in a team',
    type: 'interview',
    content: {
      sections: [
        {
          type: 'intro',
          title: '🎯 Bu Soru Ne Test Ediyor?',
          content: 'Kabin ekibi = TAKIM çalışması!\n\nBu soru şunları ölçer:\n• İşbirliği yeteneği\n• İletişim becerileri\n• Farklı insanlarla çalışma\n• Takım başarısına katkı\n\n⚠️ "I did everything alone" = YANLIŞ! Takım vurgusunu koru.'
        },
        {
          type: 'scenario',
          title: '✈️ Mülakat Senaryosu: Takım Çalışması',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'Describe a time when you worked effectively as part of a team to achieve a goal.',
              translation: 'Bir hedefe ulaşmak için takımın parçası olarak etkili çalıştığınız bir zamanı anlatın.'
            },
            {
              speaker: 'Aday (STAR)',
              text: 'SITUATION: At the hotel where I worked, we were preparing for a VIP wedding with 200 guests. It was our largest event ever, and multiple departments had to coordinate - reception, F&B, housekeeping, and security.',
              translation: 'DURUM: Çalıştığım otelde, 200 misafirli bir VIP düğünü hazırlıyorduk. Şimdiye kadarki en büyük etkinliğimizdi ve birden fazla departmanın koordine olması gerekiyordu - resepsiyon, F&B, kat hizmetleri ve güvenlik.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'TASK: My role was to be the liaison between the bride\'s family and all hotel departments. I had to ensure everyone was on the same page and problems were solved before they escalated.',
              translation: 'GÖREV: Benim rolüm gelin ailesi ile tüm otel departmanları arasında irtibat olmaktı. Herkesin aynı sayfada olduğundan ve sorunların büyümeden çözüldüğünden emin olmam gerekiyordu.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'ACTION: I created a WhatsApp group with all department heads for instant communication. Every morning, I led a 15-minute briefing to review the day\'s tasks. When the florist was delayed, I coordinated with housekeeping to rearrange the backup flowers.',
              translation: 'EYLEM: Anlık iletişim için tüm departman şefleriyle bir WhatsApp grubu oluşturdum. Her sabah günün görevlerini gözden geçirmek için 15 dakikalık bir brifing yönettim. Çiçekçi geciktiğinde, yedek çiçekleri düzenlemek için kat hizmetleriyle koordine oldum.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'I also made sure to recognize team members publicly when things went well. For example, when the chef prepared a special dish for a guest with allergies, I mentioned it to management.',
              translation: 'Ayrıca işler iyi gittiğinde ekip üyelerini halka açık olarak takdir ettiğimden emin oldum. Örneğin, şef alerjisi olan bir misafir için özel bir yemek hazırladığında, bunu yönetime bildirdim.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'RESULT: The wedding was a huge success. The bride wrote a thank-you letter to the hotel praising our coordination. The manager used our event as a case study for future large events.',
              translation: 'SONUÇ: Düğün büyük bir başarıydı. Gelin, koordinasyonumuzu öven otele bir teşekkür mektubu yazdı. Müdür etkinliğimizi gelecekteki büyük etkinlikler için bir vaka çalışması olarak kullandı.'
            }
          ]
        },
        {
          type: 'analysis',
          title: '📊 Neden Güçlü Bir Cevap?',
          content: '✅ **Takım vurgusu:** Birden fazla departman, koordinasyon\n✅ **Liderlik + İşbirliği dengesi:** Grup kurdu ama "ben" değil "biz"\n✅ **Problem çözme:** Çiçekçi krizi = hızlı adaptasyon\n✅ **Takdir etme:** Başkalarının başarısını vurguladı\n✅ **Somut sonuç:** Teşekkür mektubu, vaka çalışması'
        },
        {
          type: 'info',
          title: '✅ İyi Takım Cevabı İpuçları',
          content: '• "We" ve "our team" kullan ("I" kadar)\n• Kendi katkını belirt AMA takımı da öv\n• Farklı rollerin nasıl bir araya geldiğini anlat\n• Zorluklarda nasıl destek olduğunu göster\n• Ortak başarıyı vurgula'
        },
        {
          type: 'warning',
          title: '⚠️ Kaçınılması Gerekenler',
          content: '❌ "I did everything, my team was useless"\n❌ "I\'m better working alone"\n❌ Ekip arkadaşlarını suçlama\n❌ Sadece "I, I, I..." kullanma\n❌ Takım çatışmasını çözemediğin bir örnek'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Takım sorusunda ne vurgulamalısın?',
          options: [
            'Ben her şeyi tek başıma yaptım',
            'Kendi katkım + takımın birlikte başarısı',
            'Takımda problem çıkaran kişiler',
            'Takım olmadan daha iyi olurdum'
          ],
          correctIndex: 1,
          explanation: 'Hem kendi katkını hem de takımın ortak başarısını vurgula!'
        }
      ]
    }
  },

  'B2INT-U1-L4': {
    id: 'B2INT-U1-L4',
    title: 'Give an example of when you went above and beyond',
    type: 'interview',
    content: {
      sections: [
        {
          type: 'intro',
          title: '🎯 "Above and Beyond" = Beklentinin Ötesine Geçmek',
          content: 'Bu soru SERVİS TUTKUSUNU test eder.\n\nHavayolları şunu bilmek ister:\n• Sadece görevini mi yaparsın?\n• Yoksa ekstra mil gider misin?\n• Müşteri mutluluğu senin için önemli mi?\n\n💡 En iyi kabin memurları = minimum değil, MAKSIMUM yapanlar!'
        },
        {
          type: 'scenario',
          title: '✈️ Mülakat Senaryosu: Beklentinin Ötesinde',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'Can you give me an example of when you went above and beyond for a customer or colleague?',
              translation: 'Bir müşteri veya meslektaş için beklentinin ötesine geçtiğiniz bir örnek verebilir misiniz?'
            },
            {
              speaker: 'Aday (STAR)',
              text: 'SITUATION: While working at a hotel in Istanbul, an elderly Japanese couple checked in. They spoke very limited English and seemed confused and tired after a long flight.',
              translation: 'DURUM: İstanbul\'da bir otelde çalışırken, yaşlı bir Japon çift giriş yaptı. Çok sınırlı İngilizce konuşuyorlardı ve uzun bir uçuşun ardından kafası karışmış ve yorgun görünüyorlardı.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'TASK: Technically, my job was just to check them in and give them their key. But I could see they were struggling and seemed anxious about navigating an unfamiliar city.',
              translation: 'GÖREV: Teknik olarak işim sadece giriş yapmak ve anahtarlarını vermekti. Ama zorlandıklarını ve tanımadıkları bir şehirde gezinme konusunda endişeli göründüklerini görebiliyordum.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'ACTION: After my shift ended, I stayed an extra 30 minutes. I used Google Translate to create a personalized map for them - marking the hotel, nearby halal restaurants, the Blue Mosque, and pharmacies.',
              translation: 'EYLEM: Vardiyam bittikten sonra 30 dakika fazla kaldım. Google Translate kullanarak onlar için kişiselleştirilmiş bir harita oluşturdum - oteli, yakındaki helal restoranları, Sultanahmet Camii\'ni ve eczaneleri işaretledim.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'I also wrote useful Turkish phrases with pronunciations - "How much?", "Thank you", "Help". I laminated the paper so they could carry it easily.',
              translation: 'Ayrıca telaffuzlarıyla yararlı Türkçe ifadeler yazdım - "Ne kadar?", "Teşekkür ederim", "Yardım". Kolayca taşıyabilmeleri için kağıdı lamine ettim.'
            },
            {
              speaker: 'Aday (devam)',
              text: 'RESULT: The couple was so moved they had tears in their eyes. They came back to the desk every evening just to share their day\'s adventures with me. Before leaving, they gave me a beautiful Japanese fan and wrote to the manager recommending me for a promotion.',
              translation: 'SONUÇ: Çift o kadar duygulandı ki gözleri yaşardı. Her akşam günün maceralarını benimle paylaşmak için masaya geri geldiler. Ayrılmadan önce bana güzel bir Japon yelpazesi verdiler ve müdüre terfi için beni öneren bir mektup yazdılar.'
            }
          ]
        },
        {
          type: 'analysis',
          title: '📊 Neden Mükemmel Bir "Above and Beyond" Örneği?',
          content: '✅ **Kendi zamanını verdi:** Vardiya sonrası 30 dakika\n✅ **İnisiyatif aldı:** Kimse istemedi, kendisi yaptı\n✅ **Detaylı düşündü:** Harita, ifadeler, laminasyon\n✅ **Duygusal bağ kurdu:** Çift her gün geri geldi\n✅ **Somut sonuç:** Hediye, öneri mektubu'
        },
        {
          type: 'info',
          title: '💡 "Above and Beyond" Örnek Fikirleri',
          content: '• Mesai dışında müşteriye yardım etmek\n• Müşterinin söylemediği bir ihtiyacı fark edip karşılamak\n• Meslektaşın işini üstlenmek (hasta olduğunda)\n• Özel bir gün için sürpriz hazırlamak\n• Dil bariyerini aşmak için ekstra çaba\n• Problem çözümünde yaratıcı olmak'
        },
        {
          type: 'tip',
          content: '💡 EN İYİ "above and beyond" örnekleri: Kimse sormadı, sen gördün ve yaptın. Bu GERÇEk hizmet tutkusunu gösterir!'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: '"Above and beyond" örneği için en önemli unsur?',
          options: [
            'Çok para harcamak',
            'Görev tanımının ötesinde, kendi inisiyatifinle yapılan bir şey',
            'Yöneticinin söylediği şeyleri yapmak',
            'Çok uzun çalışmak'
          ],
          correctIndex: 1,
          explanation: 'Anahtar: Kimse istemedi, SEN gördün ve yaptın!'
        }
      ]
    }
  },

  'B2INT-U1-L5': {
    id: 'B2INT-U1-L5',
    title: 'Pratik: STAR Cevapları Hazırlama',
    type: 'simulation',
    content: {
      sections: [
        {
          type: 'intro',
          title: '🎭 STAR Hazırlık Workshopu',
          content: 'Şimdi kendi STAR cevaplarını hazırlayacaksın!\n\nHer havayolu mülakatında bu soruların bir versiyonu MUTLAKA sorulur:\n1. Zor durum\n2. Takım çalışması\n3. Zor müşteri\n4. Hata yaptığın zaman\n5. Baskı altında çalışma'
        },
        {
          type: 'scenario',
          title: '✈️ Senaryo 1: Zor Müşteri',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'Tell me about a time you dealt with an angry or demanding customer.',
              translation: 'Kızgın veya talepkar bir müşteriyle uğraştığınız bir zamanı anlatın.'
            },
            {
              speaker: 'Tavsiye',
              text: '📝 HAZIRLAMA ADIMLARI:\n\n1. SITUATION: Nerede çalışıyordun? Müşteri neden kızgındı?\n\n2. TASK: Senin sorumluluğun neydi?\n\n3. ACTION: Ne yaptın? (En az 3 adım!)\n   • Dinleme\n   • Empati\n   • Çözüm\n\n4. RESULT: Sonuç ne oldu? (Sayı veya somut ifade)',
              translation: ''
            }
          ]
        },
        {
          type: 'scenario',
          title: '✈️ Senaryo 2: Baskı Altında Çalışma',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'Describe a time you had to work under pressure. How did you handle it?',
              translation: 'Baskı altında çalışmanız gereken bir zamanı anlatın. Nasıl başa çıktınız?'
            },
            {
              speaker: 'Örnek Cevap Başlangıcı',
              text: 'SITUATION: During the holiday season at the airport lounge where I worked, we had a day where 3 flights were delayed due to weather, resulting in over 300 passengers waiting for hours...',
              translation: 'DURUM: Çalıştığım havalimanı loungeında tatil sezonunda, hava durumu nedeniyle 3 uçuşun rötar yaptığı ve 300\'den fazla yolcunun saatlerce beklediği bir gün yaşadık...'
            },
            {
              speaker: 'Tavsiye',
              text: '✅ İyi baskı örnekleri:\n• Yoğun saat/dönem\n• Personel eksikliği\n• Teknik sorun\n• Çoklu görev\n• Son dakika değişikliği',
              translation: ''
            }
          ]
        },
        {
          type: 'scenario',
          title: '✈️ Senaryo 3: Hata Yaptığın Zaman',
          dialogues: [
            {
              speaker: 'Mülakatçı',
              text: 'Tell me about a mistake you made at work. What did you learn from it?',
              translation: 'İşte yaptığınız bir hatayı anlatın. Ondan ne öğrendiniz?'
            },
            {
              speaker: 'Tavsiye',
              text: '⚠️ ÖNEMLİ: Hatayı seçerken dikkat!\n\n✅ İyi hata seçimi:\n• Ciddi olmayan ama öğretici\n• Nasıl düzelttiğini gösterir\n• Öğrenme ve büyüme\n\n❌ Kötü hata seçimi:\n• Müşteriyi ciddi şekilde zarar veren\n• Tekrar eden hatalar\n• Başkasını suçlayan',
              translation: ''
            },
            {
              speaker: 'Örnek Yaklaşım',
              text: 'FORMULA: Hata + Fark etme + Düzeltme + Öğrenme + Bir daha olmadı\n\n"In my first month, I accidentally double-booked a VIP guest\'s room. When I realized, I immediately... What I learned was... Since then, I always..."',
              translation: 'FORMÜL: Hata + Fark etme + Düzeltme + Öğrenme + Bir daha olmadı'
            }
          ]
        },
        {
          type: 'checklist',
          title: '✅ STAR Hazırlık Kontrol Listesi',
          content: '☐ En az 5 farklı STAR hikayesi hazırla\n☐ Her hikayeyi 60-90 saniyede anlat\n☐ Action bölümü en uzun olsun\n☐ Somut sayılar ve sonuçlar ekle\n☐ Yüksek sesle pratik yap\n☐ Birinin seni dinlemesini iste\n☐ Çok detaylı değil, özlü ol'
        },
        {
          type: 'tip',
          content: '💡 PRO TIP: Aynı hikayeyi farklı sorular için adapte edebilirsin! "Zor müşteri" hikayesi = "Baskı altında çalışma" hikayesi de olabilir.'
        }
      ],
      exercises: [
        {
          type: 'multipleChoice',
          question: 'Mülakat için kaç STAR hikayesi hazırlamalısın?',
          options: [
            '1-2 hikaye yeterli',
            'En az 5 farklı hikaye',
            '10+ hikaye şart',
            'Hazırlamaya gerek yok, doğaçlama'
          ],
          correctIndex: 1,
          explanation: 'En az 5 hikaye hazırla - farklı sorular için adapte edilebilir.'
        }
      ]
    }
  },

  'B2INT-U1-EXAM': {
    id: 'B2INT-U1-EXAM',
    title: 'Unit 1 Exam: STAR Method',
    type: 'exam',
    content: {
      timeLimit: 25,
      passingScore: 70,
      questions: [
        {
          type: 'multipleChoice',
          question: 'In the STAR method, what does "S" stand for?',
          options: ['Solution', 'Situation', 'Success', 'Service'],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'In the STAR method, what does "T" stand for?',
          options: ['Time', 'Team', 'Task', 'Technique'],
          correctIndex: 2
        },
        {
          type: 'multipleChoice',
          question: 'Which part of the STAR method should be the longest?',
          options: ['Situation', 'Task', 'Action', 'Result'],
          correctIndex: 2
        },
        {
          type: 'multipleChoice',
          question: 'How long should an ideal STAR answer be?',
          options: ['30 seconds', '60-90 seconds', '3-4 minutes', '5+ minutes'],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'In an "above and beyond" example, what is most important?',
          options: [
            'Spending a lot of money',
            'Doing what your manager asked',
            'Taking initiative to do something extra',
            'Working long hours'
          ],
          correctIndex: 2
        },
        {
          type: 'multipleChoice',
          question: 'When answering a teamwork question, what should you emphasize?',
          options: [
            'Only your individual achievements',
            'Your contribution AND the team\'s collective success',
            'Your teammates\' mistakes',
            'That you work better alone'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'For a "mistake" question, what is a good example?',
          options: [
            'A serious mistake that harmed the customer',
            'A small but educational mistake that you corrected and learned from',
            'Someone else\'s mistake',
            'Say you never make mistakes'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'Why is saying "We did..." risky in a STAR answer?',
          options: [
            'It\'s too long',
            'YOUR specific contribution becomes unclear',
            'It\'s grammatically incorrect',
            'It\'s not risky at all'
          ],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'How many STAR stories should you prepare for an interview?',
          options: ['1-2', '5+', '10+', 'None'],
          correctIndex: 1
        },
        {
          type: 'multipleChoice',
          question: 'What should the Result section contain?',
          options: [
            'An emotional description',
            'A concrete, measurable outcome',
            'Blaming others',
            'Vague statements'
          ],
          correctIndex: 1
        }
      ]
    }
  }
};

export default B2INT_UNIT_1;
